var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-button',{staticClass:"md-raised md-dense",staticStyle:{"background-color":"aliceblue","margin-top":"20px"},on:{"click":_vm.writeExcel}},[_vm._v("\n        Export Data to Excel\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }